import { useCallback } from 'react';
import axios from 'axios';
import api from '../../../services/api';

// Presigned-URL akışı: dosya doğrudan depolamaya PUT edilir, API'ye yalnız adresi yazılır.
// GenericFormDrawer.uploadFiles ve my-preboarding/config/index.js ile AYNI desen.
// StorageController.Presign gövdesi (`Ok(new { upload_url, file_url, filename })`) sarmalanmamış
// bir yanıt döner — res.data.data DEĞİL, doğrudan res.data okunur.
export default function useMyDocumentsApi() {
  const uploadDocument = useCallback(async (documentId, file) => {
    const presignRes = await api.post(
      `/v1/storage/presign?fileName=${encodeURIComponent(file.name)}&mimeType=${encodeURIComponent(file.type)}&purpose=${encodeURIComponent('hrDocument')}`,
    );
    const { upload_url: uploadUrl, file_url: fileUrl } = presignRes.data || {};
    if (!uploadUrl || !fileUrl) return false;

    await axios.put(uploadUrl, file, {
      headers: { 'Content-Type': file.type || 'application/octet-stream' },
    });

    const res = await api.post(`/v1/employee-document-requirements/${documentId}/upload`, { fileUrl });
    return Boolean(res.data?.status);
  }, []);

  return { uploadDocument };
}
